"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComboMultiday = void 0;
function isComboMultiday(comboType) {
    return ["CleanMultiday", "PersonalMultiday"].includes(comboType ?? "");
}
exports.isComboMultiday = isComboMultiday;
//# sourceMappingURL=isComboMultiday.js.map